import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import Select from 'react-select-plus';
import RequirableControlLabel from '../RequirableControlLabel/RequirableControlLabel';
import './CategorySelectFormGroup.css';

const isError = (error, touched) => (error && touched ? 'error' : null);

// eslint-disable-next-line object-curly-newline
const SelectFormGroup = ({ label, meta, input, options, required, ...props }) => {
  const optionsToPass = options.length > 0 && options[0].options ? options : options.map(({ id, name }) => ({ label: name, value: id }));

  const handleTheChange = (a) => {
    input.onChange(a);
    props.onFieldChange();
  };

  return (
    <FormGroup validationState={isError(meta.error, meta.touched)} >
      {label && <RequirableControlLabel required={required} >{label}</RequirableControlLabel> }
      <FormControl
        simpleValue
        clearable={false}
        componentClass={Select}
        {...input}
        {...props}
        onBlurResetsInput={false}
        onSelectResetsInput={false}
        onBlur={() => {}}
        onChange={handleTheChange}
        options={optionsToPass}
      />
      <FormControl.Feedback />
      {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock> }
    </FormGroup>
  );
};

SelectFormGroup.defaultProps = {
  meta: {},
  input: {},
  options: [],
  required: false,
  showBlank: true,
  onFieldChange: () => {},
};

SelectFormGroup.propTypes = {
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({}),
  required: PropTypes.bool,
  showBlank: PropTypes.bool,
  input: PropTypes.shape({}),
  onFieldChange: PropTypes.fn,
  options: PropTypes.arrayOf(PropTypes.shape({})),
};

export default SelectFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/CategorySelectFormGroup/CategorySelectFormGroup.jsx